import {L} from "../../lt-ng/landcare-toolkit";
import Item = L.tree.Item;

export const checkChildren = (item: Item, doCheck: boolean, classIds?: Set<number>) => {
    if (!item.children) {
        return;
    }

    item.children.forEach((child) => {
        child.extraState.metaLayerSelector.checked = doCheck;
        if (child.children) {
            checkChildren(child, doCheck);
        }
    });
};

export function checkParents(item: L.tree.Item) {
    let parent = item.parent;
    while (parent) {
        parent.extraState.metaLayerSelector.checked =
            parent.children.some((c) => c.extraState.metaLayerSelector.checked);
        parent = parent.parent;
    }
}

export const uncheckItem = (item: Item) => {
    item.checked = false;
    item.click(item);
    item.isChecked();
    L.tree.nodeToggle(item);
};